import { render } from "./codeMenu.vue?vue&type=template&id=1962498a&scoped=true"
import script from "./codeMenu.vue?vue&type=script&lang=js"
export * from "./codeMenu.vue?vue&type=script&lang=js"

import "./codeMenu.vue?vue&type=style&index=0&id=1962498a&lang=less&scoped=true"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1962498a"]])

export default __exports__